module.exports = __webpack_public_path__ + "7c01ebcc0e49fa0274c65cddff5007ad.png";